module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_9016.61cf1fab.png";